/* sov — prezzo con coupon: percentuale + link dettagli (timer spostato in modale) */
(function () {
  var last = {
    code: null,
    percent: 0,
    expiresAt: null,
    tier: '',
    windowId: '',
    endMs: null
  };
  var shouldShowInlineCouponTimer = true;
  var firstLine = document.querySelector('.price-line-first');
  var secondLine = document.querySelector('.price-line-second');

  var discValueEl = document.querySelector('.price-item.price-item--regular.price-item--discounted');
  var discCurrEl = document.querySelector('.currency-symbol.price-item--discounted');
  var pillEl = firstLine && firstLine.querySelector('.price-coupon-code-pill');

  var regularWrap = secondLine && secondLine.querySelector('.price-item.price-item--regular');
  var regularValueEl = regularWrap && regularWrap.querySelector('.price-value');
  var regularCurrEl = regularWrap && regularWrap.querySelector('.currency-symbol');

  if (
    !firstLine ||
    !secondLine ||
    !discValueEl ||
    !discCurrEl ||
    !pillEl ||
    !regularWrap ||
    !regularValueEl ||
    !regularCurrEl
  ) {
    console.warn('[price-coupon] markup non trovato');
    return;
  }

  function setFirstLineVisible(v) {
    firstLine.style.display = v ? 'flex' : 'none';
  }

  function formatAsHHMMSS(totalSeconds) {
  var s = Math.max(0, Math.floor(totalSeconds));
  var h = Math.floor(s / 3600);
  var m = Math.floor((s % 3600) / 60);
  var r = s % 60;

  function pad2(n) {
    return String(n).padStart(2, '0');
  }

  return pad2(h) + ':' + pad2(m) + ':' + pad2(r);
}


  function derivePattern(sampleStr) {
    var s = String(sampleStr || '').trim();
    var lastSepIdx = -1;

    for (var i = s.length - 1; i >= 0; i--) {
      var ch = s.charAt(i);
      if (ch < '0' || ch > '9') {
        lastSepIdx = i;
        break;
      }
    }

    var decimalSep = '';
    var decimals = 0;

    if (lastSepIdx >= 0) {
      var after = s.slice(lastSepIdx + 1).replace(/[^\d]/g, '');
      if (after.length > 0 && after.length !== 3) {
        decimalSep = s.charAt(lastSepIdx);
        decimals = after.length;
      }
    }

    var intPartStr = decimals > 0 ? s.slice(0, lastSepIdx) : s;
    var groupSep = '';

    for (var j = 0; j < intPartStr.length; j++) {
      var c = intPartStr.charAt(j);
      if (c < '0' || c > '9') {
        groupSep = c;
        break;
      }
    }

    return { decimalSep: decimalSep, groupSep: groupSep, decimals: decimals };
  }

  function parseFromSample(sampleStr) {
    var p = derivePattern(sampleStr);
    var s = String(sampleStr || '').trim();

    if (p.groupSep) s = s.split(p.groupSep).join('');
    if (p.decimals > 0 && p.decimalSep) s = s.split(p.decimalSep).join('.');

    s = s.replace(/[^\d.-]/g, '');
    var n = parseFloat(s);

    return isNaN(n) ? 0 : n;
  }

  function formatLikeSample(sampleStr, number) {
    var p = derivePattern(sampleStr);
    var sign = number < 0 ? '-' : '';
    var abs = Math.abs(number);
    var fixed = p.decimals > 0 ? abs.toFixed(p.decimals) : Math.round(abs).toString();
    var parts = fixed.split('.');
    var intPart = parts[0];
    var decPart = parts[1];

    if (p.groupSep) {
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(intPart)) intPart = intPart.replace(rgx, '$1' + p.groupSep + '$2');
    }

    var out = decPart != null ? intPart + (p.decimalSep || ',') + decPart : intPart;
    return sign + out;
  }

  var baseSample = regularValueEl.textContent || '';
  var basePrice = parseFromSample(baseSample);
  regularWrap.dataset.basePrice = String(basePrice);
  regularWrap.dataset.baseSample = baseSample;
  updateCouponFlagSavingsLine();
  
  pillEl.innerHTML = '';

var pillPercentEl = document.createElement('span');
pillPercentEl.className = 'pill-percent';

var pillTimerEl = null;
if (shouldShowInlineCouponTimer) {
  pillTimerEl = document.createElement('span');
  pillTimerEl.className = 'pill-timer';
  pillTimerEl.hidden = true;
}

var pillDetailsLink = (function () {
  var a =
    document.querySelector('.sov-coupon-link-details') ||
    document.querySelector('.sov-open-pdp_coupon');

  if (a) return a.cloneNode(true);

  var b = document.createElement('button');
  b.type = 'button';
  b.className = 'sov-open-pdp_coupon sov-coupon-link-details';
  b.setAttribute('aria-haspopup', 'dialog');
  b.setAttribute('aria-expanded', 'false');
  b.textContent = 'Details';
  return b;
})();

pillEl.appendChild(pillPercentEl);

if (pillTimerEl) {
  pillEl.appendChild(document.createTextNode(' '));
  pillEl.appendChild(pillTimerEl);
}

pillEl.appendChild(document.createTextNode(' '));
pillEl.appendChild(pillDetailsLink);


  var __expiryCheckId = null;
  var __couponEndMs = NaN;

  function removeAllDiscounts() {
    var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: '' })
    }).catch(function () {});
  }

  function onCouponExpiredPdp() {
    try {
      removeAllDiscounts();
    } catch (e) {}

    try {
      document.dispatchEvent(
        new CustomEvent('sov:discount:changed', { detail: { code: '', percent: 0, expiresAt: '' } })
      );
    } catch (e) {}

    try {
      applyDiscountUI(null, 0, null);
    } catch (e) {}
  }

  function applyDiscountUI(code, percent, expiresAt) {
    percent = Number(percent);
    last.code = code || null;
    last.percent = percent || 0;
    last.expiresAt = expiresAt || null;

    last.endMs = expiresAt ? Date.parse(expiresAt) : null;

    if (__expiryCheckId) {
      clearInterval(__expiryCheckId);
      __expiryCheckId = null;
    }

    if (!percent || percent <= 0) {
      setFirstLineVisible(false);
      discValueEl.hidden = true;
      discCurrEl.hidden = true;
      pillEl.hidden = true;
      pillPercentEl.textContent = '';
      if (pillTimerEl) {
  pillTimerEl.textContent = '';
  pillTimerEl.hidden = true;
}

      regularWrap.classList.remove('has-coupon-applied');

      var baseCents2 = Math.round(basePrice * 100);
      regularValueEl.textContent = formatLikeSample(baseSample, baseCents2 / 100);
      return;
    }

    var baseCents = Math.round(basePrice * 100);
    var discCents = baseCents - Math.floor((baseCents * percent) / 100);
    var discounted = discCents / 100;

    discValueEl.textContent = formatLikeSample(baseSample, discounted);
    discCurrEl.textContent = regularCurrEl.textContent || '';
    discValueEl.hidden = false;
    discCurrEl.hidden = false;

    pillPercentEl.textContent = '−' + percent + '%';

__couponEndMs = expiresAt ? Date.parse(expiresAt) : NaN;
last.endMs = isNaN(__couponEndMs) ? null : __couponEndMs;

if (pillTimerEl) {
  pillTimerEl.textContent = '';
  pillTimerEl.hidden = true;
}

if (!isNaN(__couponEndMs)) {
  __expiryCheckId = setInterval(function () {
    var leftMs = __couponEndMs - Date.now();

    if (leftMs <= 0) {
      if (pillTimerEl) {
        pillTimerEl.textContent = '00:00:00';
        pillTimerEl.hidden = true;
      }

      clearInterval(__expiryCheckId);
      __expiryCheckId = null;
      onCouponExpiredPdp();
      return;
    }

    if (pillTimerEl) {
      var leftSec = Math.ceil(leftMs / 1000);
      pillTimerEl.textContent = formatAsHHMMSS(leftSec);
      pillTimerEl.hidden = false;
    }
  }, 1000);
}


    pillEl.hidden = false;
    regularWrap.classList.add('has-coupon-applied');
    setFirstLineVisible(true);
  }

function updateCouponFlagSavingsLine()
{
	var fieldset = document.querySelector('.dt-fieldset[data-dt-visible="1"][data-dt-payload]');
	if (!fieldset) return;

	var line = fieldset.querySelector('[data-dt-savings-line]');
	var amountEl = fieldset.querySelector('[data-dt-savings-amount]');
	if (!line || !amountEl) return;

	var pctEl = fieldset.querySelector('#coupon-vip .dt-pct');
	var m = pctEl ? String(pctEl.textContent || '').match(/(\d{1,3})/) : null;
	var pct = m ? parseInt(m[1], 10) : 0;

	if (!pct || pct <= 0) {
		line.hidden = true;
		return;
	}

	if (typeof basePrice !== 'number' || isNaN(basePrice) || basePrice <= 0) {
		line.hidden = true;
		return;
	}

	var baseCentsLocal = Math.round(basePrice * 100);
	var saveCents = Math.floor((baseCentsLocal * pct) / 100);

	if (!saveCents || saveCents <= 0) {
		line.hidden = true;
		return;
	}

	var amount = formatLikeSample(baseSample, saveCents / 100);
	var curr = regularCurrEl ? String(regularCurrEl.textContent || '').trim() : '';

	amountEl.textContent = curr ? (amount + ' ' + curr) : amount;
	line.hidden = false;
}


  function refreshBaseFromDom() {
    var sampleNow = regularValueEl.textContent || '';
    if (!sampleNow || sampleNow === baseSample) return false;

    baseSample = sampleNow;
    basePrice = parseFromSample(sampleNow);
    regularWrap.dataset.basePrice = String(basePrice);
    regularWrap.dataset.baseSample = baseSample;
    return true;
  }

  document.addEventListener(
    'sov:discount:applied',
    function (e) {
      var d = (e && e.detail) || {};
      last.tier = d.Tier || d.tier || last.tier || '';
      last.windowId = d.WindowId || d.windowId || last.windowId || (window.__dt_currentWindowId || '');
      try {
        applyDiscountUI(d.code, d.percent, d.expiresAt);
        updateCouponFlagSavingsLine();
      } catch (err) {
        console.warn('[price-coupon] errore aggiorna ui', err);
      }
    },
    { passive: true }
  );

  window.addEventListener(
    'variantGalleryUpdated',
    function () {
      requestAnimationFrame(function () {
        if (refreshBaseFromDom()) applyDiscountUI(last.code, last.percent, last.expiresAt);
        updateCouponFlagSavingsLine();
      });
    },
    { passive: true }
  );

  document.addEventListener(
    'variant:changed',
    function () {
      requestAnimationFrame(function () {
        if (refreshBaseFromDom()) applyDiscountUI(last.code, last.percent, last.expiresAt);
        updateCouponFlagSavingsLine();
      });
    },
    { passive: true }
  );

  document.addEventListener(
    'product:variant:change',
    function () {
      requestAnimationFrame(function () {
        if (refreshBaseFromDom()) applyDiscountUI(last.code, last.percent, last.expiresAt);
        updateCouponFlagSavingsLine();
      });
    },
    { passive: true }
  );

  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].type === 'characterData' || muts[i].type === 'childList') {
        if (refreshBaseFromDom()) applyDiscountUI(last.code, last.percent, last.expiresAt);
        updateCouponFlagSavingsLine();
        break;
      }
    }
  });

  mo.observe(regularValueEl, { characterData: true, subtree: true, childList: true });

  setFirstLineVisible(false);
})();
